import React from 'react';
import classes from './SectionHeader.css';

const sectionHeader = props => {
    return (
        <div className={classes.Header}>
            <img className={classes.Logo} src={props.logo} alt="" />
            {/* <h2 className={classes.SectionTitle}>{props.title}</h2> */}
            {props.subtitle ? (
                <h3 className={classes.SectionSubtitle}>{props.subtitle}</h3>
            ) : null}

            {props.children}
        </div>
    );
};

export default sectionHeader;



// WEBPACK FOOTER //
// ./src/components/SectionHeader/SectionHeader.js